import { Platform } from 'react-native';
import { supabase } from './supabase';
import { onboardingResumptionEndpoint, parseResumableOnboardingIntents } from './onboardingResumptionContract';

/** No module cache: each mount/retry checks current server truth for this user. */
export async function fetchResumableOnboardingIntents(userId: string, signal: AbortSignal) {
    const { data: { session }, error } = await supabase.auth.getSession();
    if (error || !session?.access_token || session.user.id !== userId) {
        throw new Error('Saved-project session changed');
    }
    const response = await fetch(onboardingResumptionEndpoint(
        Platform.OS === 'web', typeof window === 'undefined' ? undefined : window.location.hostname,
    ), {
        headers: { Accept: 'application/json', Authorization: `Bearer ${session.access_token}` },
        cache: 'no-store', credentials: 'omit', referrerPolicy: 'no-referrer', signal,
    });
    if (response.status !== 200) throw new Error('Saved-project lookup unavailable');
    const intents = parseResumableOnboardingIntents(await response.json());
    const { data: current } = await supabase.auth.getSession();
    if (signal.aborted || current.session?.user.id !== userId) throw new Error('Saved-project session changed');
    return intents;
}
